<script>

  async function sha256 (message) {
    message = message.toLowerCase()
    const msgBuffer = new TextEncoder().encode(message)
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
    return hashHex
  }

  async function onSubmit (e) {
    const formData = new FormData(e.target)
    const data = {}
    for (let field of formData) {
      const [key, value] = field
      data[key] = value
    }
    
    const current = new URL(window.location.href)
    const hash = await sha256(data.email)
    current.searchParams.set('s', hash)
    window.location.href = current
  }

</script>

<form on:submit|preventDefault={onSubmit}>

  <p>Enter your email address to view:</p>

  <input type="email" name="email" id="email" placeholder="name@inbox.com" />
  <input type="submit" value="Submit">

</form>

<style>
	form {
    padding-top: 50px;
    text-align: center;
  }
</style>